import { useState } from "react";
import { submitSaleInquiryDb } from "../api/cmsApi";

export default function ServiceSalesInquiryForm({ serviceTitle, serviceSlug }) {
  const [form, setForm] = useState({ name: "", email: "", company: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await submitSaleInquiryDb({
        name: form.name.trim(),
        email: form.email.trim(),
        company: form.company.trim(),
        phone: form.phone.trim(),
        interest: serviceTitle || "Service inquiry",
        message: form.message.trim(),
        source: serviceSlug ? `service-${serviceSlug}` : "service",
      });
      setSent(true);
      setForm({ name: "", email: "", company: "", phone: "", message: "" });
      setTimeout(() => setSent(false), 6000);
    } catch (err) {
      setError(err?.message || "Could not submit. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="section solution-detail-inquiry animate-on-scroll" id="service-inquiry">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="contact-page-form-card">
              <div className="contact-page-section-head">
                <span>Tell us what you need</span>
                <div className="contact-page-section-line" />
              </div>
              <p className="contact-page-form-desc">
                Share a few details about your {serviceTitle ? `${serviceTitle} ` : ""}requirements and our sales team will follow up shortly.
              </p>
              {sent ? (
                <div className="contact-page-success">
                  <i className="bi bi-check-circle me-2" aria-hidden="true" />
                  Thank you! We will contact you soon.
                </div>
              ) : (
                <form onSubmit={onSubmit}>
                  {error ? (
                    <div className="contact-page-success" style={{ background: "#fef2f2", color: "#b91c1c" }}>
                      {error}
                    </div>
                  ) : null}
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="contact-page-label-field">Full Name</label>
                      <input
                        className="contact-page-input"
                        placeholder="Your name"
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="contact-page-label-field">Email</label>
                      <input
                        type="email"
                        className="contact-page-input"
                        placeholder="you@company.com"
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="contact-page-label-field">Company</label>
                      <input
                        className="contact-page-input"
                        placeholder="Company name"
                        value={form.company}
                        onChange={(e) => setForm({ ...form, company: e.target.value })}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="contact-page-label-field">Phone</label>
                      <input
                        className="contact-page-input"
                        placeholder="+91 xxxxx xxxxx"
                        value={form.phone}
                        onChange={(e) => setForm({ ...form, phone: e.target.value })}
                      />
                    </div>
                    <div className="col-12">
                      <label className="contact-page-label-field">Message</label>
                      <textarea
                        className="contact-page-textarea"
                        rows={4}
                        placeholder="Tell us about your project or requirements..."
                        value={form.message}
                        onChange={(e) => setForm({ ...form, message: e.target.value })}
                        required
                      />
                    </div>
                    <div className="col-12">
                      <button type="submit" className="contact-page-submit" disabled={submitting}>
                        <i className="bi bi-send-fill" aria-hidden="true" />
                        {submitting ? "Submitting..." : "Submit inquiry"}
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
